<template>
  <div class="comparativeDetails">
    <div class="header">
      <div class="title">
        {{ satementData.reconciliationName }}
      </div>
    </div>
    <div class="content">
      <Tabs v-model="tabs" @on-click="changeTab">
        <TabPane :label="item.tabName + '（' + item.num + '）'" :name="item.tabName" v-for="(item, index) in tabData"
          :key="index"></TabPane>
      </Tabs>
      <div class="firstTable" v-if="summaryData.length > 0">
        <div class="tableHead">
          <div class="headItem"></div>
          <div class="headItem">记录数合计</div>
          <div class="headItem">保费合计</div>
          <div class="headItem">费用合计</div>
          <div v-if="satementData.reconciliationType == 1" class="headItem">首期基础费用合计</div>
          <div v-if="satementData.reconciliationType == 1" class="headItem">首期限时加费合计</div>
          <div v-if="satementData.reconciliationType == 4" class="headItem">续期基础费用合计</div>
          <div v-if="satementData.reconciliationType == 4" class="headItem">续年服务津贴合计</div>
        </div>
        <div class="tableRow" v-for="(item, index) in summaryData" :key="index">
          <div class="header">{{ item.type }}</div>
          <div class="rowItem">{{ item.totalNumber || '0' }}</div>
          <div class="rowItem">{{ item.totalFee || '0' }}</div>
          <div class="rowItem" :class="{'orange':item.isCompulsory == 1 && item.isOk == 1,'red':item.isOk == 2}">{{ item.totalCommission || '0' }}</div>
          <div class="rowItem" :class="{'orange':item.isCompulsory == 1 && item.isOk == 1,'red':item.isOk == 2}" v-if="satementData.reconciliationType == 1">{{ item.totalBaseCommission || '0' }}</div>
          <div class="rowItem" :class="{'orange':item.isCompulsory == 1 && item.isOk == 1,'red':item.isOk == 2}" v-if="satementData.reconciliationType == 1">{{ item.totalActCommission || '0' }}</div>
          <div class="rowItem" :class="{'orange':item.isCompulsory == 1 && item.isOk == 1,'red':item.isOk == 2}" v-if="satementData.reconciliationType == 4">{{ item.totalRenewBaseCommission || '0' }}
          </div>
          <div class="rowItem" :class="{'orange':item.isCompulsory == 1 && item.isOk == 1,'red':item.isOk == 2}" v-if="satementData.reconciliationType == 4">{{ item.totalRenewAllowance || '0' }}</div>
        </div>
      </div>
      <div class="search-tools">
        <div class="search-box btn3">
          <div class="input-item" v-if="tabs != '一致'">
            <span class="label">对比结果类型</span>
            <Select v-model="searchParams.isOk" clearable>
              <Option value="1" v-if="tabs != '异常'">一致</Option>
              <Option value="2">费用不一致</Option>
              <Option value="3">供应商没有的记录</Option>
              <Option value="4">系统未生成费用</Option>
              <Option value="5">系统无此保单</Option>
              <Option value="6">供应商多出的记录</Option>
            </Select>
          </div>
          <div class="input-item">
            <span class="label">保单号</span>
            <Input v-model="searchParams.policyNo" placeholder="请输入" clearable />
          </div>
          <Button type="primary" @click="getList()">搜索</Button>
        </div>
      </div>
      <Table :columns="columns" :data="tableData" id="table">
        <template slot-scope="{ row, index }" slot="comparisonStatus">
          <div class="detail">
            <span v-if="row.isOk == '5'">-</span>
            <span v-else>{{ row.comparisonStatus }}</span>
            <Poptip trigger="hover" placement="top-start" :offset="-26" transfer-class-name="my-poptip"
              v-if="row.isOk == '4'">
              <span class="tip-icon">?</span>
              <div slot="content">
                <span>{{ row.failMsg }}</span>
              </div>
            </Poptip>
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <div class="detail">
            <div v-if="row.isCompulsory == '0'">
              <span class="table-btn" v-if="row.isOk == '2'" @click="strongFlat(row)">强平</span>
              <span class="table-btn" v-if="row.isOk == '6'" @click="addStatement(row)">确认并对比</span>
              <span class="table-btn" v-if="row.isOk == '3' || row.isOk == '6'" @click="removeStatement(row)">移出对账单</span>
              <span class="table-btn" v-if="row.isOk == '4' || row.isOk == '5'"
                @click="recontrast(row)">重新对比</span>
            </div>
            <Dropdown :transfer="true" trigger="hover" @on-click="dropdownClick($event, row)" v-else>
              <span style="color: #A8ADB7;">已强平<Icon type="ios-arrow-down"></Icon></span>
              <DropdownMenu slot="list">
              <DropdownItem name="cancel">
                <span class="table-btn">撤销强平操作</span>
              </DropdownItem>
            </DropdownMenu>
            </Dropdown>
          </div>
        </template>
      </Table>
      <div class="pageBox">
        <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="pageChange"
          style="text-align: center" />
      </div>
    </div>
    <div class="footer">
      <!-- <Button type="primary">保存</Button> -->
      <Button type="primary" ghost @click="back(backUrl)">返回</Button>
      <Button type="primary" ghost @click.stop="lastStep()">上一步</Button>
      <Tooltip content="包括重新生成系统数据进行对比、批量移除供应商没有的记录、批量加入供应商有的记录并对比" placement="top" v-if="satementData.reconciliationType != 2">
        <Button type="primary" ghost @click="allTreatment">批量处理</Button>
      </Tooltip>
      <Tooltip content="包括批量移出供应商没有的记录，根据费用项规则重新生成系统数据并对比" placement="top" v-else>
        <Button type="primary" ghost @click="allTreatment">批量处理并计算</Button>
      </Tooltip>
      
      <Button type="primary" ghost @click="allStrongFlat">批量强平</Button>
      <Button type="primary" @click="endStatement()" :disabled="allRight != '1'">完成对账</Button>
      <Button type="primary" ghost @click="reStatement">重新开始对账</Button>
      <Button type="primary" ghost @click="daochu()">导出系统数据</Button>
    </div>
  </div>
</template>

<script>
import { pageTool,common } from "@/api/mixins";
export default {
  props: ['checkId'],
  mixins: [pageTool,common],
  data() {
    return {
      searchParams: {},
      satementData: {},// 对账单数据
      tabs: '汇总',
      allRight: "",
      summaryData: [],
      backUrl: '', //返回链接
      tabData: {},
      columns: [
        {
          title: '保单号',
          key: 'policyNo',
          align: 'center',
          width: "180",
          fixed: "left",
        },
        {
          title: "保单年度",
          align: "center",
          key: "commissionIndex",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: '交费期次',
          key: 'commissionPeriods',
          align: 'center',
          width: "100",
        },
        {
          title: '保险产品',
          key: 'productName',
          align: 'center',
          width: "200",
        },
        {
          title: '险种名称',
          key: 'productTypeName',
          align: 'center',
          width: "200",
        },
        {
          title: '保单状态',
          key: 'policyStatus',
          align: 'center',
          width: "100",
        },
        {
          title: '承保日期',
          key: 'insureTime',
          align: 'center',
          width: "200",
        },
        {
          title: '生效日期',
          key: 'effectTime',
          align: 'center',
          width: "200",
        },
        {
          title: '实收日期',
          key: 'actualReceiveTime',
          align: 'center',
          width: "200",
        },
        {
          title: '保障期',
          key: 'guaranteeValueDesc',
          align: 'center',
          width: "100",
        },
        {
          title: '交费期',
          key: 'payValueDesc',
          width: "140",
          align: 'center',
        },
        {
          title: "费用类型",
          align: "center",
          minWidth: 140,
          tooltip: true,
          render(h, params) {
            const commissionType = params.row.commissionType;
            if ((commissionType == 1||commissionType == 3)&&params.row.commissionIndex > 1){
              return <span>续期基础费用</span>;
            } else if (commissionType == 1||commissionType == 3) {
              return <span>基础费用</span>;
            } else if (commissionType == 2||commissionType == 4||commissionType == 11||commissionType == 12) {
              return <span>限时加费活动
                <Tooltip
                trigger="hover"
                content="content"
                transfer={true}
              >
                <span class="tip-icon">?</span>
                <div slot="content">
                  <div>{ params.row.activityName }</div>
                  <span>{ '(' +  params.row.activityBegin+ '至'+ params.row.activityEnd+ ')' }</span>
                </div>
              </Tooltip>
              </span>;
            } else if (commissionType == 5) {
              return <span>后置费用</span>;
            }else if(commissionType == 13||commissionType == 14){
              return <span>梯度加费
                <Tooltip
                trigger="hover"
                content="content"
                transfer={true}
              >
                <span class="tip-icon">?</span>
                <div slot="content">
                  <div>{ params.row.activityName }</div>
                  <span>{ '(' +  params.row.activityBegin+ '至'+ params.row.activityEnd+ ')' }</span>
                </div>
              </Tooltip>
              </span>;
            }else if(commissionType == 15||commissionType == 16){
              return <span>续年服务津贴</span>;
            }else if(commissionType == 17||commissionType == 18){
              return <span>继续率费用</span>;
            }
          },
        },
        {
          title: "继续率系数",
          align: "center",
          key: "coefficient",
          minWidth: 100,
          tooltip: true,
        },
        {
          title: '对比结果',
          slot: 'comparisonStatus',
          width: "180",
          align: 'center',
        },
        {
          title: '保费',
          align: 'center',
          children: [
            {
              title: '系统保费',
              key: 'fee',
              width: "120",
              align: 'center',
              render(h, params) {
                if(params.row.isOk == '5'){
                  return <span>-</span>;
                }else{
                  return <span>{params.row.fee}</span>;
                }
              }
            },
            {
              title: '供应商保费',
              key: 'supplierFee',
              width: "120",
              align: 'center',
            },
          ]
        },
        {
          title: '费率',
          align: 'center',
          children: [
            {
              title: '系统费率',
              key: 'commission',
              align: 'center',
              width: "120",
              render(h, params) {
                  return <span>{Number(params.row.commission) ? params.row.commission : '-'}</span>;
              }
            },
            {
              title: '供应商费率',
              key: 'supplierCommission',
              align: 'center',
              width: "120",
              render(h, params) {
                  return <span>{Number(params.row.supplierCommission) ? params.row.supplierCommission : '-'}</span>;
              }
            },
          ]
        },
        {
          title: '费用',
          align: 'center',
          children: [
            {
              title: '系统费用',
              key: 'commissionPrice',
              align: 'center',
              width: "120",
              render(h, params) {
                if(params.row.isOk == '5'){
                  return <span>-</span>;
                }else{
                  return <span>{params.row.commissionPrice}</span>;
                }
              }
            },
            {
              title: '供应商费用',
              key: 'supplierCommissionPrice',
              align: 'center',
              width: "120",
            },
          ]
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: "230",
        },
      ]
    }
  },
  mounted() {
    this.backUrl = this.$route.query.backUrl;
    this.detail()
    this.allAgree()
    this.initListAjax('/buz/molCommissionConsult/detailsPageByCheckId')
      },
  methods: {
    daochu() {
      if(this.$units.pointAction('offline_8_1_5')){
        this.loading = true;
        this.$http({
          url: "/buz/molCommissionConsult/detailsExportByCheckId",
          type: "POST",
          responseType: "blob",
          data: {
            checkId: this.$route.query.id || this.checkId,
            tabs:this.tabs,
            ...this.searchParams
          },
        })
          .then((res) => {
            this.loading = false;
            this.$units.daochu(res);
          })
          .catch((e) => {
            this.loading = false;
          });
        }else{
        this.$Message.error('无权操作，请联系您的上级')
      }
    },
    //isOk，对比状态（0待对比；1一致，2费用不一致，3供应商没有的记录，4系统未生成费用，5系统无此保单）
    // 更多操作
    dropdownClick(name, row) {
      if (name == 'cancel') {
        if(this.$units.pointAction('offline_8_1_2')){
          this.$http({
            url: '/buz/molCommissionConsult/undoCompulsory',
            type: 'POST',
            data: {
              id: row.id
            },
          }).then((res) => {
            this.getTabs()
            this.getSummaryData()
            this.allAgree()
          })
        }else{
        this.$Message.error('无权操作，请联系您的上级')
      }
      } 
    },
    addStatement(row){
      if(this.$units.pointAction('offline_8_1_2')){
        this.$http({
          url: '/buz/molCommissionConsult/join',
          type: 'POST',
          data: {
            id: row.id
          },
        }).then((res) => {
          this.$notice.success("操作成功");
          this.allAgree()
          this.getSummaryData()
          this.getTabs()
        })
      }else{
        this.$Message.error('无权操作，请联系您的上级')
      }
    },
    getColumns() {
      if (this.satementData.reconciliationType == 1 || this.satementData.reconciliationType == 2) {
        let idx = ''
        idx = this.columns.findIndex(item => item.key == 'commissionIndex')
        this.columns.splice(idx, 1);
        idx = this.columns.findIndex(item => item.key == 'actualReceiveTime')
        this.columns.splice(idx, 1);
      }
      if (this.satementData.reconciliationType == 1 || this.satementData.reconciliationType == 2 || this.satementData.reconciliationType == 3 || this.satementData.reconciliationType == 5) {
        let idx = ''
        idx = this.columns.findIndex(item => item.key == 'coefficient')
        this.columns.splice(idx, 1);
      }
      window.setTimeout(()=>{
        document.getElementById("table").querySelectorAll(".ivu-table-body")[0].scrollLeft = document.getElementById("table").querySelectorAll(".ivu-table-body")[0].scrollWidth 
      },300)
    },
    // 重新对账
    reStatement() {
      if(this.$units.pointAction('offline_8_1_2')){
        this.$notice.inquiry("是否重置全部流程重新开始对账？").then(async () => {
          this.$http({
            url: '/buz/commissionReconciliation/jumpBack',
            type: 'POST',
            data: {
              id: this.$route.query.id || this.checkId
            },
          }).then((res) => {
            if (res.data.step == '1') {
              this.$emit('backStep')
            }
          })
        }).catch((res) => {
          console.log(res);
        });
      }else{
        this.$Message.error('无权操作，请联系您的上级')
      }
    },
    // 结算清单是否一致，激活完成对账按钮
    allAgree() {
      this.$http({
        url: '/buz/molCommissionConsult/consultAllIsOk',
        type: 'POST',
        data: {
          checkId: this.$route.query.id || this.checkId
        },
      }).then((res) => {
        this.allRight = res.data
      })
    },
    // 全部处理
    allTreatment() {
      if(this.$units.pointAction('offline_8_1_2')){
        this.$notice.inquiry("请确认是否批量处理？").then(async () => {
          this.$http({
            url: '/buz/molCommissionConsult/batchDeal',
            type: 'POST',
            data: {
              checkId: this.$route.query.id || this.checkId,
            },
          }).then((res) => {
            this.$notice.success("操作成功，请核对对比结果");
            this.getTabs()
            this.getSummaryData()
            this.allAgree()
          })
        }).catch((res) => {
          console.log(res);
        });
      }else{
        this.$Message.error('无权操作，请联系您的上级')
      }
    },
    changeTab() {
      this.pageNo = 1
      this.searchParams.isOk = ''
      this.getSummaryData()
      this.getList()
    },
    listCallback(res) {
      // isOk，对比状态（0待对比；1一致，2费用不一致，3供应商没有的记录，4系统未生成费用，5系统无此保单）
      // isCompulsory，是否强平（0否，1是）
      res.data.forEach(item => {
        
          if (item.isCompulsory == 1) {
            item.cellClassName = {
              commission: 'demo-table-cell-name2',
              supplierCommission: 'demo-table-cell-name2',
              commissionPrice: 'demo-table-cell-name2',
              supplierCommissionPrice: 'demo-table-cell-name2',
            }
          } 
          if (item.isOk == 2) {
            item.cellClassName = {
              commission: 'demo-table-cell-name1',
              supplierCommission: 'demo-table-cell-name1',
              commissionPrice: 'demo-table-cell-name1',
              supplierCommissionPrice: 'demo-table-cell-name1',
            } 
        }
      });
    },
    // 全部强平
    allStrongFlat() {
      if(this.$units.pointAction('offline_8_1_2')){
        this.$notice.inquiry("请确认是否批量强平？").then(() => {
          this.$http({
            url: '/buz/molCommissionConsult/batchCompulsory',
            type: 'POST',
            data: {
              checkId: this.$route.query.id || this.checkId
            },
          }).then(() => {
            this.$notice.success("操作成功，请核对对比结果");
            this.getTabs()
            this.getSummaryData()
            this.allAgree()
          })
        }).catch((res) => {
          console.log(res);
        });
      }else{
        this.$Message.error('无权操作，请联系您的上级')
      }
    },
    // 强平接口
    strongFlat(row) {
      if(this.$units.pointAction('offline_8_1_2')){
        this.$notice.inquiry("强平后系统保费、费率、费用数据将会调整为供应商对应数据。请确认是否强平？").then(() => {
          this.$http({
            url: '/buz/molCommissionConsult/compulsory',
            type: 'POST',
            data: {
              id: row.id
            },
          }).then((res) => {
            this.$notice.success("操作成功");
            this.getTabs()
            this.allAgree()
            this.getSummaryData()
            
          })
        });
      }else{
        this.$Message.error('无权操作，请联系您的上级')
      }

    },
    // 移除对账单
    removeStatement(row) {
      if(this.$units.pointAction('offline_8_1_2')){
        this.$http({
          url: '/buz/molCommissionConsult/kickOut',
          type: 'POST',
          data: {
            id: row.id
          },
        }).then((res) => {
          this.$notice.success("操作成功");
          this.allAgree()
          this.getSummaryData()
          this.getTabs()
        })
      }else{
        this.$Message.error('无权操作，请联系您的上级')
      }
    },
    // 重新对比
    recontrast(row) {
      if(this.$units.pointAction('offline_8_1_2')){
        this.$http({
          url: '/buz/molCommissionConsult/againContrast',
          type: 'POST',
          data: {
            id: row.id
          },
        }).then((res) => {
          this.$notice.success("操作成功，请核对对比结果");
          this.allAgree()
          this.getSummaryData()
          this.getTabs()
        })
      }else{
        this.$Message.error('无权操作，请联系您的上级')
      }
    },
    getTabs() {
      this.$http({
        url: '/buz/molCommissionConsult/queryTabsInfo',
        type: 'POST',
        data: {
          checkId: this.$route.query.id || this.checkId,
        },
      }).then((res) => {
        if (res.data) {
          this.tabData = res.data
          this.getList()
        }
      })
    },
    setListParams(params) {
      params.checkId = this.$route.query.id || this.checkId;
      params.tabs = this.tabs;
    },
    //获取汇总数据
    getSummaryData() {
      this.$http({
        url: '/buz/molCommissionConsult/summaryTabs',
        type: 'POST',
        data: {
          checkId: this.$route.query.id || this.checkId,
          tabs: this.tabs,
        },
      }).then((res) => {
        if (res.data) {
          this.summaryData = res.data
        }
      })
    },
    detail() {
      this.$http({
        url: "/buz/commissionReconciliation/read/detail",
        type: "GET",
        data: { id: this.$route.query.id || this.checkId },
      }).then((res) => {
        this.satementData = res.data
        this.getSummaryData()
        this.getTabs()
        this.getColumns()
      });
    },
    endStatement() {
      if(this.$units.pointAction('offline_8_1_2')){
        this.$notice.inquiry("请确认对账单是否已经无误？").then(() => {
          this.nextStep()
        }).catch((res) => {
          console.log(res);
        });
      }else{
        this.$Message.error('无权操作，请联系您的上级')
      }
    },
    // 分页
    pageChange(pageNo) {
      this.pageNo = pageNo;
      this.getList(pageNo)
    },
    lastStep() {

      this.$http({
        url: '/buz/commissionReconciliation/edit',
        type: 'POST',
        data: {
          step: 2,
          id: this.$route.query.id || this.checkId,
          agreementId:this.satementData.agreementId
        },
      }).then(() => {
        this.$emit('lastStep')
      })
    },
    nextStep() {
      // 完成对账接口
      this.$http({
        url: '/buz/commissionReconciliation/verify',
        type: 'POST',
        data: {
          id: this.$route.query.id || this.checkId
        },
      }).then(() => {
        this.$emit('nextStep')
      })
    },
  }
}
</script>

<style lang="scss" scoped>
@import "./comparativeDetails.scss";
</style>